import React from "react";
import { Row, Col } from "react-bootstrap";
import usePoolToken from "../../../hooks/usePoolToken";
import { formatPercentage } from "../../../utils/format";
import useGenericCall from "../../../hooks/useGenericCall";
import { useOffchainBorrowable } from "../../../hooks/useOffchain";
import { PoolTokenType } from "impermax-sdk";


export default function SupplyAPR({ amount }: { amount: number }) {
  const poolTokenType = usePoolToken();
  if (poolTokenType == PoolTokenType.Collateral) return null;

  const supplyAPR = useGenericCall(
    useOffchainBorrowable(), 
    offchainBorrowable => offchainBorrowable.getNextSupplyAPR(amount),
    [amount]
  );

  return (
    <Row>
      <Col xs={6}>Supply APR:</Col>
      <Col xs={6} className="text-right">{formatPercentage(supplyAPR)}</Col>
    </Row>
  );
}